import { useEffect, useState } from 'react'

import { fetchPartnerRequestById } from 'clickNgo/entities/partner'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import Logger from 'core/utils/Logger'

/** Whether the partner heads its group, from the partner's record; the sales team and the extended
 *  info ask for the same record, so the three share one request. `false` until it is known. */
export const usePartnerIsHeadquarters = (partnerId: string) => {
  const [answer, setAnswer] = useState<{ partnerId: string; isHeadquarters: boolean } | null>(null)

  useEffect(() => {
    if (!partnerId || answer?.partnerId === partnerId) {
      return
    }

    let isCancelled = false

    fetchPartnerRequestById(partnerId, { cacheKey: partnerId })
      .then((partner) => partner?.hierarchyType === PartnerHierarchyType.HEADQUARTERS)
      .catch((error: unknown) => {
        Logger.error('Error while loading the partner hierarchy:', error)

        return false
      })
      .then((isHeadquarters) => {
        if (!isCancelled) {
          setAnswer({ partnerId, isHeadquarters })
        }
      })

    return () => {
      isCancelled = true
    }
  }, [answer?.partnerId, partnerId])

  return answer?.partnerId === partnerId && answer.isHeadquarters
}
